export const DEFAULT_MESSAGE = "We couldn't find what you were looking for";
